import React, { useEffect, useState } from "react";
import "./managepackage.css";

const DeliveryDetails = () => {
  const [deliveries, setDeliveries] = useState([]);
  const [confirms, setConfirms] = useState([]);
  const [config, setConfig] = useState(null);

  // Load config
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch("/config.json");
        const cfg = await res.json();
        setConfig(cfg);
      } catch (err) {
        console.error("Error loading config:", err);
      }
    };
    loadConfig();
  }, []);

  // Fetch deliveries
  useEffect(() => {
    if (!config) return;
    const fetchDeliveries = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.FETCH_ACCEPTED_ORDERS}`, {
          method: "POST",
          credentials: "include",
        });
        const data = await res.json();
        if (data.success) setDeliveries(data.data);
      } catch (err) {
        console.error("Error fetching deliveries:", err);
      }
    };
    fetchDeliveries();
  }, [config]);

  // Fetch confirm deliveries
  useEffect(() => {
    if (!config) return;
    const fetchConfirms = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.FETCH_CONFIRM_DELIVERY}`, {
          method: "POST",
          credentials: "include",
        });
        const data = await res.json();
        if (data.success) setConfirms(data.data.map(c => ({ ...c, showOtpInput: false })));
      } catch (err) {
        console.error("Error fetching confirm delivery:", err);
      }
    };
    fetchConfirms();
  }, [config]);

  // Delivery form handlers
  const handleInputChange = (deliveryId, field, value) => {
    setDeliveries(prev =>
      prev.map(d => d.payment_row_id === deliveryId ? { ...d, [field]: value } : d)
    );
  };

  const handleImageUpload = (e, deliveryId) => {
    const file = e.target.files[0];
    if (!file) return;
    setDeliveries(prev =>
      prev.map(d => d.payment_row_id === deliveryId ? { ...d, delivery_image_file: file } : d)
    );
  };

  const handleOutForDelivery = async (delivery) => {
    if (!delivery.price || !delivery.tracking_id || !delivery.delivery_image_file) {
      alert("Please enter price, tracking ID, and upload an image.");
      return;
    }

    const formData = new FormData();
    formData.append("user_id", delivery.user_id);
    formData.append("product_id", delivery.product_id);
    formData.append("price", delivery.price);
    formData.append("tracking_id", delivery.tracking_id);
    formData.append("expected_delivery_date", delivery.expected_delivery_date);
    formData.append("delivery_image", delivery.delivery_image_file);

    try {
      const res = await fetch(`${config.BASE_URL}${config.UPDATE_DELIVARY_STATUS}`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });
      const data = await res.json();
      if (data.success) {
        alert("Marked as Out for Delivery!");
        setDeliveries(prev => prev.filter(d => d.payment_row_id !== delivery.payment_row_id));
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      console.error("Error sending delivery data:", err);
      alert("Failed to send delivery data");
    }
  };

  // OTP handlers
  const handleSendOtp = async (order) => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.CONFIRM_MAIL_OTP}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ user_id: order.user_id, product_id: order.product_id }),
      });
      const data = await res.json();

      if (data.status && data.otp) {
  alert(data.message);
  setConfirms(prev =>
    prev.map(c =>
      c.order_id === order.order_id
        ? { ...c, showOtpInput: true, otpInput: "", otpServer: data.otp } 
        : c
    )
  );
} else {
  alert("Failed to send OTP: " + data.message);
}
    } catch (err) {
      console.error(err);
      alert("Error sending OTP.");
    }
  };

  const handleOtpInput = (orderId, value) => {
    setConfirms(prev =>
      prev.map(c => c.order_id === orderId ? { ...c, otpInput: value } : c)
    );
  };

  const handleVerifyOtp = async (order) => {
 if (!order.otpInput || order.otpInput.trim() === "") {
  alert("Enter OTP.");
  return;
}

// Compare with OTP received from PHP
if (order.otpInput !== order.otpServer.toString()) {
  alert("Invalid OTP");
  return;
}



    // OTP correct → update order status
    try {
      const res = await fetch(`${config.BASE_URL}${config.UPDATE_ORDER_STATUS}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ user_id: order.user_id, product_id: order.product_id }),
      });
      const data = await res.json();
      if (data.success) {
        alert("Delivery confirmed!");
        setConfirms(prev => prev.filter(c => c.order_id !== order.order_id));
      } else {
        alert("Failed to confirm: " + data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Error confirming delivery.");
    }
  };

  return (
    <div className="delivery-container">
      <h2>Delivery Details</h2>
      <table className="delivery-table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Address</th>
            <th>Mobile number</th>
            <th>Product Name</th>
            <th>Price</th>
            <th>Tracking ID</th>
            <th>Expected Delivery Date</th>
            <th>Upload Image</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {deliveries.length > 0 ? deliveries.map(d => (
            <tr key={d.payment_row_id}>
              <td>{d.user_name}</td>
              <td>{d.address}</td>
              <td>{d.mobile}</td>
              <td>{d.product_name}</td>
              <td>
                <input type="number" value={d.price || ""} onChange={(e) =>
                  handleInputChange(d.payment_row_id, "price", e.target.value)} placeholder="Enter price" />
              </td>
              <td>
                <input type="text" value={d.tracking_id || ""} onChange={(e) =>
                  handleInputChange(d.payment_row_id, "tracking_id", e.target.value)} placeholder="Enter tracking ID" />
              </td>
              <td>
                <input type="date" value={d.expected_delivery_date || ""} onChange={(e) =>
                  handleInputChange(d.payment_row_id, "expected_delivery_date", e.target.value)} />
              </td>
              <td>
                <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, d.payment_row_id)} />
                {d.delivery_image && <img src={d.delivery_image} alt="Delivery" style={{ width: "50px", marginTop: "5px" }} />}
              </td>
              <td>
                <button className="update-btn" onClick={() => handleOutForDelivery(d)}>Out for Delivery</button>
              </td>
            </tr>
          )) : (
            <tr><td colSpan="9">No delivery records found.</td></tr>
          )}
        </tbody>
      </table>

      <h2 style={{ marginTop: "50px" }}>Confirm Delivery</h2>
      <table className="delivery-table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Mobile Number</th>
            <th>Email</th>
            <th>Product Name</th>
            <th>Expected Delivery Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {confirms.length > 0 ? confirms.map(c => (
            <tr key={c.order_id}>
              <td>{c.user_name}</td>
              <td>{c.mobile}</td>
              <td>{c.email}</td>
              <td>{c.product_name}</td>
              <td>{c.expected_delivery_date}</td>
              <td>
                {!c.showOtpInput ? (
                  <button className="update-btn" onClick={() => handleSendOtp(c)}>Send OTP</button>
                ) : (
                  <>
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={c.otpInput || ""}
                      onChange={(e) => handleOtpInput(c.order_id, e.target.value)}
                      style={{ marginBottom: "5px", display: "block" }}
                    />
                    <button className="update-btn" onClick={() => handleVerifyOtp(c)}>Verify OTP</button>
                  </>
                )}
              </td>
            </tr>
          )) : (
            <tr><td colSpan="6">No delivery confirmations found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DeliveryDetails;
